import React from 'react'
import { useSelector } from 'react-redux'

const AddButtonWithLabel = (props) => {
 const permission=useSelector((state)=>state.viewRolesAndPermissionSlice.employeePermission)
      const userRole = useSelector((state) => state.userRoleSlice.value);

  const{onClick,text,style}=props

  return (
    <>
    {(userRole==="admin"|| permission?.addProduct===true) &&
    <button class="add-btn-global-new" onClick={onClick} style={style}>
        <div class="sign">+</div>
        <div class="text">{text}</div>
    </button>}
    </>
  )
}

export default AddButtonWithLabel